import { INTER } from '../../styles/fonts'
import styled, { keyframes } from 'styled-components'

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
`

interface SnackbarTextProps {
  $textAlign?: 'left' | 'center' | 'right'
}

export const SnackbarContainer = (styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 12px 24px;
  border-radius: 6px;
  z-index: 9999;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  animation: ${fadeInUp} 0.3s ease-in-out;
  min-width: 120px;
  max-width: 90%;
  will-change: opacity, transform;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const SnackbarText = (styled.span<SnackbarTextProps>`
  margin: 0;
  font-family: ${INTER.light};
  font-size: 12px;
  text-align: ${props => props.$textAlign || 'center'};
  color: white;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
